import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'


Vue.use(Router)

const routes = [
    {
      path: '/',
      name: 'home',
       component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
	{
	  path: '/login',
	  name: 'login',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  // which is lazy-loaded when the route is visited.
	  component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
	}
  ];


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (store.getters.token) {
    next()
  }
  else {
    if (to.path === '/login') {
      next()
    } 
    else {
      next({
        path: '/login',
		query:to.query
      })
    }
  }
})

export default router